<section class="table-page modal-tarea-anterior">
  <header class="modal-tarea-anterior__header">
    <div class="modal-tarea-anterior__title-wrap">
      <div class="modal-tarea-anterior__icon">
        <mat-icon>fact_check</mat-icon>
      </div>
      <div class="table-page__copy">
        <h2>{{ titulo }}</h2>
        <p>Información y evidencias de la tarea</p>
      </div>
    </div>

    <button type="button" mat-icon-button class="table-page__action-btn modal-tarea-anterior__close" (click)="closeModal()" aria-label="Cerrar modal">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="modal-tarea-anterior__body">
    <div class="modal-tarea-anterior__content-grid">
      <section class="modal-tarea-anterior__form-section">
        <form [formGroup]="tareaAltaFormGroup">
          <div class="row">
            <div class="col-sm-6">
              <mat-form-field appearance="outline">
                <mat-label>Proyecto</mat-label>
                <mat-select #proyectoSelect formControlName="proyectoCtrl" panelClass="modal-tarea-anterior-select-panel" [(ngModel)]="tarea.idProyecto" (openedChange)="cerrarSelectAlterno($event, 'proyecto')">
                  <mat-option *ngFor="let item of proyectos" [value]="item.id">
                    {{ item.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field appearance="outline" class="example-full-width">
                <input formControlName="nombreCtrl" matInput type="text" [(ngModel)]="tarea.nombre" aria-label="Nombre de la tarea">
                <mat-label>Nombre de la tarea</mat-label>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <mat-form-field appearance="outline">
                <textarea formControlName="descripcionCtrl" matInput maxlength="240" rows="8" [(ngModel)]="tarea.descripcion" aria-label="Descripción de la tarea"></textarea>
                <mat-label>Descripción de la tarea</mat-label>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field class="example-full-width" appearance="outline">
                <input matInput [matDatepicker]="pickerInicio" formControlName="fechaInicioCtrl" [(ngModel)]="fechaInicio" [min]="minDate" [max]="maxDate" (ngModelChange)="onChangFecha($event, true)" aria-label="Fecha de inicio">
                <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                <mat-datepicker #pickerInicio></mat-datepicker>
                <mat-label>Fecha de inicio</mat-label>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field class="example-full-width" appearance="outline">
                <input matInput [matDatepicker]="pickerFin" formControlName="fechaFinalCtrl" readonly [(ngModel)]="fechaFin" aria-label="Fecha de fin">
                <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                <mat-datepicker #pickerFin></mat-datepicker>
                <mat-label>Fecha de fin</mat-label>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field class="example-full-width" appearance="outline">
                <input matInput formControlName="horaInicioCtrl" type="time" [(ngModel)]="horaInicio" aria-label="Hora de inicio">
                <mat-label>Hora de inicio</mat-label>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field class="example-full-width" appearance="outline">
                <input matInput type="time" max="23:59" formControlName="horaFinCtrl" [(ngModel)]="horaFin" readonly aria-label="Hora de fin">
                <mat-label>Hora de fin</mat-label>
              </mat-form-field>
              <mat-error>
                <div *ngIf="tareaAltaFormGroup.controls.horaFinCtrl.invalid && (tareaAltaFormGroup.controls.horaFinCtrl.dirty || tareaAltaFormGroup.controls.horaFinCtrl.touched)">
                  Las horas del día no alcanzan para cubrir el tiempo invertido.
                </div>
              </mat-error>
            </div>
            <div class="col-6">
              <mat-form-field class="example-full-width" appearance="outline">
                <input matInput formControlName="horasInvertidasCtrl" soloNumeroPuntos type="text" maxlength="10" (ngModelChange)="sumarHoras($event, true)" pattern="^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$" [(ngModel)]="tarea.tiempoTotalInvertidoStr" aria-label="Horas invertidas">
                <mat-label>Horas invertidas</mat-label>
              </mat-form-field>
              <mat-error>
                <div *ngIf="tareaAltaFormGroup.controls.horasInvertidasCtrl.invalid && (tareaAltaFormGroup.controls.horasInvertidasCtrl.dirty || tareaAltaFormGroup.controls.horasInvertidasCtrl.touched)">
                  <strong *ngIf="tareaAltaFormGroup.controls.horasInvertidasCtrl.errors.pattern">El formato debe ser HH:MM:SS.</strong>
                </div>
              </mat-error>
            </div>
            <div class="col-6">
              <mat-form-field appearance="outline">
                <mat-label>Estatus</mat-label>
                <mat-select #estatusSelect [(ngModel)]="tarea.estatus" panelClass="modal-tarea-anterior-select-panel" formControlName="estatusCtrl" (openedChange)="cerrarSelectAlterno($event, 'estatus')">
                  <mat-option *ngFor="let enum of listaEstatus" [value]="enum.value">{{ enum.value }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>
      </section>

      <aside class="modal-tarea-anterior__evidence-panel">
        <header class="modal-tarea-anterior__evidence-header">
          <div>
            <span class="modal-tarea-anterior__section-label">Evidencias</span>
            <h3>Archivos adjuntos</h3>
            <p>
              {{ (evidencia?.length || 0) + (tarea?.evidencias?.length || 0) }}
              {{ ((evidencia?.length || 0) + (tarea?.evidencias?.length || 0)) === 1 ? "archivo" : "archivos" }}
            </p>
          </div>

          <div class="modal-tarea-anterior__evidence-toolbar">
            <input #evidenceInput type="file" id="nameFile" class="modal-tarea-anterior__file-input"
              accept="image/*, application/*,file_extension|audio/*|video/mp4,video/*|image/*|media_type"
              mozdirectory directory multiple [disabled]="btnAgrega" (change)="subirEvidencia()" aria-label="Agregar" />
            <button type="button" mat-raised-button class="modal-tarea-anterior__add-evidence" [disabled]="btnAgrega" (click)="evidenceInput.click()">
              <mat-icon>add_circle</mat-icon>
              Agregar
            </button>
            <button type="button" mat-button class="modal-tarea-anterior__remove-evidence" [hidden]="btnElimina" (click)="eliminarEvidencia()">
              <mat-icon>delete_outline</mat-icon>
              Quitar
            </button>
          </div>
        </header>

        <div class="modal-tarea-anterior__evidence-body">
          <ng-container *ngIf="evidencia?.length || tarea?.evidencias?.length; else sinEvidencias">
            <mat-selection-list *ngIf="evidencia?.length" class="modal-tarea-anterior__selection-list" [(ngModel)]="selectedOptions" (ngModelChange)="onNgModelChange($event)" [ngModelOptions]="{ standalone: true }">
              <mat-list-option *ngFor="let item of evidencia" [value]="item" class="modal-tarea-anterior__pending-evidence">
                <mat-icon>attach_file</mat-icon>
                <span>{{ item.name }}</span>
              </mat-list-option>
            </mat-selection-list>

            <div *ngIf="tarea?.evidencias?.length" class="modal-tarea-anterior__saved-evidence-list">
              <article class="modal-tarea-anterior__saved-evidence" *ngFor="let evidencias of tarea.evidencias">
                <mat-icon>description</mat-icon>
                <span>{{ evidencias.nombreArchivo }}</span>
                <div class="modal-tarea-anterior__saved-evidence-actions">
                  <button type="button" class="table-page__action-btn" (click)="consultaImagenEvidencia(evidencias)" [attr.aria-label]="'Ver evidencia ' + evidencias.nombreArchivo">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <a #downloadFile aria-label="Descargar evidencia"></a>
                  <button type="button" class="table-page__action-btn" (click)="descargaEvidencia(evidencias)" [attr.aria-label]="'Descargar evidencia ' + evidencias.nombreArchivo">
                    <mat-icon>cloud_download</mat-icon>
                  </button>
                </div>
              </article>
            </div>
          </ng-container>

          <ng-template #sinEvidencias>
            <div class="modal-tarea-anterior__empty-evidence">
              <mat-icon>upload_file</mat-icon>
              <strong>Sin evidencias adjuntas</strong>
              <span>Agrega los archivos que respaldan esta tarea.</span>
            </div>
          </ng-template>
        </div>
      </aside>
    </div>
  </div>

  <footer class="modal-tarea-anterior__footer" mat-dialog-actions>
    <button mat-raised-button class="app-form-btn app-form-btn--secondary" (click)="limpiaListaEvidencias()" [hidden]="evidencia?.length === 0">
      <mat-icon>delete_outline</mat-icon>
      Limpiar
    </button>
    <button mat-raised-button class="app-form-btn app-form-btn--secondary modal-tarea-anterior__footer-cancel" (click)="closeModal()">
      Cancelar
    </button>
    <button mat-raised-button class="app-form-btn app-form-btn--primary modal-tarea-anterior__footer-save" (click)="guardar()" [disabled]="tareaAltaFormGroup.invalid">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </footer>
</section>
